<template>
    <div>
        <article :id="wtfToken.id" class="panel large pair entry">
            <header>
                <h3>{{ wtfToken.metadata.title }} <span><small>by</small> {{ wtfToken.metadata.author }}</span></h3>
            </header>
            <div class="primary">
                <template v-if="wtfToken.media.type === 'image'">
                    <a :href="`/assets/wtf/${wtfToken.media.original}`" rel="nofollow">
                        <picture>
                            <template v-if="wtfToken.media.file.substr(-4) === '.gif'">
                                <source
                                    :srcset="`/assets/wtf/${wtfToken.media.file.replace('720.gif', '360.jpg')} 360w, /assets/wtf/${wtfToken.media.file.replace('.gif', '.jpg')} 720w, /assets/wtf/${wtfToken.media.file.replace('720.gif', '720@2x.jpg')} 1440w`"
                                    media="(prefers-reduced-motion:reduce)"
                                    sizes="(min-width:1280px) 720px, calc(100vw - 6.5rem)"
                                    type="image/jpeg">
                            </template>

                            <source
                                :srcset="`/assets/wtf/${wtfToken.media.file.replace('720', '360')} 360w, /assets/wtf/${wtfToken.media.file} 720w, /assets/wtf/${wtfToken.media.file.replace('720', '720@2x')} 1440w`"
                                :type="wtfToken.media.mime"
                                sizes="(min-width:1280px) 720px, calc(100vw - 6.5rem)">

                            <img :alt="wtfToken.metadata.alt ?? wtfToken.metadata.title"
                                 :data-src="`/assets/wtf/${wtfToken.media.file}`"
                                 :height="wtfToken.media.height"
                                 :width="wtfToken.media.width"
                                 loading="lazy"
                                 title="View Original"
                                 src=""/>
                        </picture>
                    </a>
                </template>
                <template v-else-if="wtfToken.media.type === 'video'">
                    <video :data-poster="`/assets/wtf/${wtfToken.media.poster}`" :width="wtfToken.media.width" controls
                           preload="none">
                        <source :src="`/assets/wtf/${wtfToken.media.file}`" :type="wtfToken.media.mime">
                    </video>
                </template>
                <p v-else-if="wtfToken.media.type === 'ascii'">
                    {{ wtfToken.media.original }}
                </p>
            </div>

            <div class="secondary">
                <h4 role="heading" aria-level="3">Metadata</h4>
                <dl>
                    <dt>Description</dt>
                    <dd class="multiline">{{ wtfToken.metadata.description ?? '' }}</dd>

                    <dt>Artist</dt>
                    <dd>{{ wtfToken.metadata.author }}</dd>

                    <template v-if="wtfToken.media.dimensions">
                        <dt class="left half"><abbr title="Multipurpose Internet Mail Extensions">MIME</abbr> Type</dt>
                        <dd class="left half">{{ wtfToken.media.mime }}</dd>
                        <dt class="right half">Dimensions</dt>
                        <dd class="right half">{{ wtfToken.media.dimensions }}</dd>
                    </template>
                    <template v-else>
                        <dt><abbr title="Multipurpose Internet Mail Extensions">MIME</abbr> Type</dt>
                        <dd>{{ wtfToken.media.mime }}</dd>
                    </template>
                </dl>
                <h4 class="uc" role="heading" aria-level="3">NFT</h4>
                <dl>
                    <dt>Token ID</dt>
                    <dd>{{ wtfToken.token.name ?? wtfToken.metadata.title }}</dd>

                    <template v-if="wtfToken.ipfs">
                        <dt>IPFS Files</dt>
                        <dd><a :href="wtfToken.ipfs.media" target="_blank"><span :class="`icon-${wtfToken.media.type}`"></span>Media</a></dd>
                        <dd><a :href="wtfToken.ipfs.json" target="_blank"><span class="icon-code"></span>JSON Metadata</a></dd>
                        <dd><a :href="wtfToken.ipfs.coa" target="_blank"><span class="icon-cert"></span>Certificate of Authenticity</a></dd>
                    </template>

                    <dt class="left half">Total Tokens Issued</dt>
                    <dd class="left half">{{ wtfToken.token.issued.toLocaleString('en-US') }}</dd>

                    <dt class="right half">Amount Burnt</dt>
                    <dd class="right half">{{ wtfToken.token.burnt.toLocaleString('en-US') }}</dd>

                    <template v-if="wtfToken.id.includes('wtf21') || wtfToken.id.includes('wtfascii')">
                        <dt>Price per Token</dt>
                        <dd>{{ wtfToken.token.price.hada.toLocaleString('en-US') }} Hada / {{ wtfToken.token.price.hadalite.toLocaleString('en-US') }} Hadalite</dd>
                    </template>
                </dl>

                <!--<a class="button mb-4" :href="`https://xumm.community/?issuer=rHADAXwGgVtqjgTdN6g2YQoqiKSKZRANXG&currency=${wtfToken.token.hex}&limit=${wtfToken.token.limit}`"
                   rel="noopener nofollow"
                   target="_blank">
                    Set TrustLine
                </a>-->

                <!--<a class="button action" href="javascript:void(0);" rel="noopener nofollow" onclick="getXummUrl('<?= $e['id'] ?>', 'hada')">Buy Now w/ Hada</a> -->
                <!--<a class="button action" href="javascript:void(0);" rel="noopener nofollow" onclick="getXummUrl('<?= $e['id'] ?>', 'hadalite')">Buy Now w/ Hadalite</a> -->

                <template v-if="wtfToken.token.upgradable">
                    <template v-if="signedIn">
                        <div class="mt-4">
                            <upgrade-token
                                :token="wtfToken.token"
                                :channel="channel">
                            </upgrade-token>
                        </div>
                    </template>
                    <div v-else>
                        <i class="connect-wallet-text">Connect your wallet to upgrade {{ wtfToken.metadata.title }} to XLS20</i>
                    </div>
                </template>
            </div>
        </article>
    </div>
</template>

<script>
export default {
    name: "WtfNfToken",

    props: {
        wtfToken: Object,
        channel: String,
        signedIn: Boolean,
    },
}
</script>
